<template>
  <div class='plates'>
    <div class="container">
      <div class="page-header">
        <h1>Welcome to LyonPlates!
          <small>using Vue.js and firebase</small>
        </h1>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">Create a new post</h3>
        </div>
        <div class="panel-group">
          <form id="form" @submit.prevent="addBook">
            <div v-bind:class="{'form-group': true, 'has-danger': errors.has('bookTitle')}">
              <!-- TODO: try making each of these entries a row -- setting label to be 2 cols and box to be 10 -->
              <label for="bookTitle">Title:</label>
              <input id="bookTitle" name="bookTitle" type="text" class="form-control" placeholder="Book title" v-model="newBook.title" v-validate="'required|min:2'" aria-describedby="titleHelp">
              <div><small id="titleHelp" class="form-text text-muted">Enter the title of the book</small></div>
              <span class="form-control-feedback" v-if="errors.has('bookTitle')">{{errors.first('bookTitle')}}</span>
            </div>
            <div v-bind:class="{'form-group': true, 'has-danger': errors.has('bookAuthor')}">
              <label for="bookAuthor">Author:</label>
              <input id="bookAuthor" name="bookAuthor" type="text" class="form-control" placeholder="Book author" v-model="newBook.author" v-validate="'required|min:2'" aria-describedby="authorHelp">
              <div><small id="authorHelp" class="form-text text-muted">Enter the author of the book</small></div>
              <span class="form-control-feedback" v-if="errors.has('bookAuthor')">{{errors.first('bookAuthor')}}</span>
            </div>
            <div v-bind:class="{'form-group': true, 'has-danger': errors.has('bookUrl')}">
              <label for="bookUrl">Url:</label>
              <input type="text" id="bookUrl" name="bookUrl" v-validate="'url'" class="form-control" aria-describedby="urlHelp" v-model="newBook.url">
              <div><small id="urlHelp" class="form-text text-muted">Enter a url to view the book online</small></div>
              <span class="form-control-feedback" v-if="errors.has('bookUrl')">{{errors.first('bookUrl')}}</span>

            </div>
            <input type="submit" class="btn btn-primary" value="Add Book">
          </form>
        </div>
      </div>
      <div class='panel-body'>
        <table class='table table-striped'>
          <thead>
            <tr>
              <th>Title</th>
              <th>Author</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="post in recentPosts">
              <td>
                <a v-bind:href='post.url'>{{post.title}}</a>
              </td>
              <td>{{post.author}}</td>
              <td>{{post.date | formatJustDate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <input type="submit" class="btn btn-primary" value="Logout" v-on:click='logout'>

    <!-- <div class="container">
      <ais-index
        app-id="latency"
        api-key="3d9875e51fbd20c7754e65422f7ce5e1"
        index-name="bestbuy"
      >
        <ais-search-box></ais-search-box>
        <ais-results>
          <template scope="{ result }">
            <h2>
              <ais-highlight :result="result" attribute-name="name"></ais-highlight>
            </h2>
          </template>
        </ais-results>
      </ais-index>
    </div> -->

  </div>
</template>

<script>
import firebase from 'firebase';
import moment from 'moment';
import { db, scripturePostsCollection } from '../firebase';

const scripturePostsRef = db.collection('scripturePosts');
const posts = scripturePostsCollection;
const mostRecentPost = posts.orderBy('date', 'desc').limit(1);
const recentPosts = posts.orderBy('date', 'desc').limit(2);

export default {
  name: 'Plates',
  data() {
    return {
      newBook: {
        title: '',
        author: '',
        url: 'http://',
      },
      recentPosts: [],
    };
  },
  created() {
    let firstTime = true;
    recentPosts.get().then((queryData) => {
      queryData.forEach((doc) => {
        if (firstTime) {
          firstTime = false;
        } else {
          this.recentPosts.push(doc.data());
        }
      });
    });
    const realTimeUpdates = () => {
      mostRecentPost.onSnapshot((queryData) => {
        queryData.docChanges.forEach((change) => {
          if (change.type === 'added') {
            this.recentPosts.splice(0, 0, change.doc.data());
          }
        });
      });
    };
    realTimeUpdates();
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('/login');
      });
    },
    addBook() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          scripturePostsRef.add({
            title: this.newBook.title,
            author: this.newBook.author,
            url: this.newBook.url,
            date: new Date(),
            user: firebase.auth().currentUser.uid,
          });
          this.newBook.title = '';
          this.newBook.author = '';
          this.newBook.url = 'http://';
        }
      });
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}


.form-control-feedback {
  color: red;
  position: relative;
  display: inline;
}

</style>



// WEBPACK FOOTER //
// src/components/Plates.vue